import { combineReducers } from "redux"
import { vincule } from "./vinculeNumberReducer"

const vinculeNumberReducers = combineReducers({
    vincule
})

export default vinculeNumberReducers
